import { MessageCircle, Instagram, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, MAPS_URL, PHONE_DISPLAY, WA_FLOAT } from "@/lib/constants";

const CHANNELS = [
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: PHONE_DISPLAY,
    href: WA_FLOAT,
    testid: "contact-channel-whatsapp",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: INSTAGRAM_HANDLE,
    href: INSTAGRAM_URL,
    testid: "contact-channel-instagram",
  },
  {
    icon: MapPin,
    label: "Localização",
    value: "Teresina – PI | Zona Norte",
    href: MAPS_URL,
    testid: "contact-channel-location",
  },
];

export const Contact = () => (
  <section id="contato" data-testid="contact-section" className="bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        overline="Contato"
        title="Entre em contato"
        text="Estamos prontos para cuidar de você. Fale com a Clínica COB pelo canal que preferir."
      />

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-4xl mx-auto">
        {CHANNELS.map((channel, i) => (
          <Reveal key={channel.label} delay={i * 0.08} className="h-full">
            <a
              href={channel.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={channel.testid}
              className="group flex h-full flex-col items-center rounded-2xl border border-cob-light bg-white p-7 text-center transition-all duration-500 hover:-translate-y-1.5 hover:border-cob-gold/50 hover:shadow-[0_22px_45px_-22px_rgba(6,63,50,0.3)]"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-cob-light/60 text-cob-green transition-all duration-500 group-hover:bg-cob-dark group-hover:text-cob-gold group-hover:scale-110">
                <channel.icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <span className="mt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-cob-gold">
                {channel.label}
              </span>
              <span className="mt-2 text-[15px] font-semibold text-cob-dark break-words">{channel.value}</span>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <div className="mt-12 text-center">
          <a
            href={WA_FLOAT}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-cta-whatsapp"
            className="inline-flex items-center gap-2.5 rounded-full bg-cob-green px-9 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-cob-dark hover:shadow-[0_16px_35px_-12px_rgba(6,63,50,0.5)]"
          >
            <MessageCircle className="h-4.5 w-4.5" />
            Falar pelo WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
